module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/school/school-add/school-add.component.css
// module id = ./src/app/components/school/school-add/school-add.component.css
// module chunks = main